import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { MapComponent } from '../../map/components/map-component/map.component';
import { CurrentStateService } from '../../../core/services/current-state.service';
import { MENU_OPTIONS } from '../../../shared/constants/left-menu-option';
import { LocalStorageService } from '../../../shared/services/utilities/local-storage.service';

@Component({
  selector: 'app-control-point-page',
  standalone: true,
  imports: [
    CommonModule,
    MapComponent
  ],
  templateUrl: './control-point-page.component.html',
  styleUrls: ['./control-point-page.component.scss']
})
export class ControlPointPageComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  menuType = MENU_OPTIONS.CONTROL_POINT;

  constructor(
    private currentStateService: CurrentStateService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    // Définir le menu actuel
    this.currentStateService.setCurrentMenu(MENU_OPTIONS.CONTROL_POINT);
    this.localStorageService.setItem('currentMenu', MENU_OPTIONS.CONTROL_POINT);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}